// Page loads
//   → initAjaxinate()
//   → Engine reads page 2 URL from hidden link
//   → Scroll listener active
// User scrolls near grid bottom
//   → loadPage() fetches page 2
//   → Products appended with data-page-index="2"
//   → Pagination link updated to page 3
//   → Scroll event updates bar highlight to "2"
// User applies a filter
//   → facets.js replaces #ProductGridContainer HTML
//   → onProductGridUpdated()
//   → Fresh engine on new grid, all items tagged page 1
// Last page reached
//   → No more #AjaxinateTargetLink
//   → Scroll listener removed, pagination cleared

function getGridItemLinks(container) {
  return Array.from(container.querySelectorAll(':scope > li'))
    .map(function (li) {
      var link = li.querySelector('a[href]');
      return link ? link.getAttribute('href') : null;
    })
    .filter(Boolean);
}

function CustomAjaxinate(settings) {
  var defaults = { container: '#product-grid', pagination: '#AjaxinatePagination', offset: 300 };
  this.settings = Object.assign({}, defaults, settings);
  this.container = document.querySelector(this.settings.container);
  this.pagination = document.querySelector(this.settings.pagination);
  this.requestPending = false;
  this.scrollEvent = null;

  if (this.container && this.pagination) {
    this.initialize();
  }
}

CustomAjaxinate.prototype.destroy = function () {
  if (this.scrollEvent) {
    window.removeEventListener('scroll', this.scrollEvent);
    this.scrollEvent = null;
  }
};

CustomAjaxinate.prototype.finishLoading = function () {
  this.requestPending = false;
};

CustomAjaxinate.prototype.revertToButtonMode = function () {
  this.destroy();
  this.finishLoading();

  var scope = this.container
    ? this.container.closest('.collection, .template-search__results')
    : null;
  if (!scope) return;

  scope.classList.remove('ajaxinate-infinite-active');
  scope.querySelectorAll('.ajaxinate-load-more').forEach(function (btn) {
    btn.disabled = false;
    btn.removeAttribute('aria-busy');
  });
};

CustomAjaxinate.prototype.initialize = function () {
  this.extendedPagination = this.pagination.querySelector('#AjaxinateTargetLink');
  if (this.extendedPagination) {
    this.nextPageUrl = this.extendedPagination.href;
    this.bindScroll();
  }
};

CustomAjaxinate.prototype.bindScroll = function () {
  var self = this;

  if (this.scrollEvent) {
    window.removeEventListener('scroll', this.scrollEvent);
  }

  this.scrollEvent = function () {
    if (self.requestPending) return;

    var rect = self.container.getBoundingClientRect();
    var nearContainerBottom = rect.bottom <= window.innerHeight + self.settings.offset;

    if (nearContainerBottom) {
      if (!self.nextPageUrl) {
        self.destroy();
        return;
      }
      self.requestPending = true;
      self.loadPage();
    }
  };

  window.addEventListener('scroll', this.scrollEvent);
};

CustomAjaxinate.prototype.loadPage = function () {
  var xhr = new XMLHttpRequest();
  var self = this;

  xhr.open('GET', this.nextPageUrl);
  xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
  xhr.onreadystatechange = function () {
    if (xhr.readyState !== 4) return;

    if (xhr.status !== 200) {
      self.revertToButtonMode();
      ajaxinateInstance = null;
      return;
    }

    var doc = new DOMParser().parseFromString(xhr.responseText, 'text/html');
    var incomingContainer = doc.querySelector(self.settings.container);
    var incomingPagination = doc.querySelector(self.settings.pagination);
    var existingLinks = getGridItemLinks(self.container);

    if (incomingContainer && incomingContainer.innerHTML.trim() !== '') {
      var parserDiv = document.createElement('div');
      parserDiv.innerHTML = incomingContainer.innerHTML;
      var incomingItems = parserDiv.querySelectorAll(':scope > li');
      var hasDuplicates = false;

      if (incomingItems.length > 0) {
        var firstIncomingLink = incomingItems[0].querySelector('a[href]');
        if (firstIncomingLink && existingLinks.includes(firstIncomingLink.getAttribute('href'))) {
          hasDuplicates = true;
        }
      }

      if (hasDuplicates) {
        self.destroy();
        self.pagination.innerHTML = '';
        self.finishLoading();
        return;
      }

      var urlObj = new URL(self.nextPageUrl, window.location.origin);
      var pageNum = urlObj.searchParams.get('page') || '1';
      Array.from(incomingContainer.children).forEach(function (child) {
        child.setAttribute('data-page-index', pageNum);
      });

      self.container.insertAdjacentHTML('beforeend', incomingContainer.innerHTML);
    }

    var incomingLink = incomingPagination ? incomingPagination.querySelector('#AjaxinateTargetLink') : null;

    if (!incomingPagination || !incomingLink || incomingLink.href === self.nextPageUrl) {
      self.destroy();
      self.pagination.innerHTML = '';
      self.finishLoading();
      window.dispatchEvent(new Event('scroll'));
      return;
    }

    self.pagination.innerHTML = incomingPagination.innerHTML;
    self.finishLoading();
    self.initialize();
    window.dispatchEvent(new Event('scroll'));
  };
  xhr.onerror = function () {
    self.revertToButtonMode();
    ajaxinateInstance = null;
  };
  xhr.send();
};

var ajaxinateInstance = null;
var paginationIndicatorInitialized = false;

window.runAjaxinateEngine = function () {
  var grid = document.getElementById('product-grid');
  var pagination = document.getElementById('AjaxinatePagination');
  if (!grid || !pagination) return;

  if (ajaxinateInstance) {
    ajaxinateInstance.destroy();
    ajaxinateInstance = null;
  }

  ajaxinateInstance = new CustomAjaxinate({
    container: '#product-grid',
    pagination: '#AjaxinatePagination',
    offset: 300,
  });
};

window.onProductGridUpdated = function () {
  // Reset to "button mode" after facet/sort re-renders.
  if (ajaxinateInstance) {
    ajaxinateInstance.destroy();
    ajaxinateInstance = null;
  }

  var grid = document.getElementById('product-grid');
  var scope = grid ? grid.closest('.collection, .template-search__results') : null;

  if (scope) {
    scope.classList.remove('ajaxinate-infinite-active');
    scope.querySelectorAll('.ajaxinate-load-more').forEach(function (btn) {
      btn.disabled = false;
      btn.removeAttribute('aria-busy');
    });
  }

  document.querySelectorAll('#product-grid > li').forEach(function (el) {
    el.setAttribute('data-page-index', '1');
  });
  updateActivePageIndicator();
};

function getPaginationPageItems() {
  var grid = document.getElementById('product-grid');
  if (!grid) return [];

  var scope = grid.closest('.collection, .template-search__results');
  if (!scope) return [];

  var list = scope.querySelector('.pagination__list');
  if (!list) return [];

  return Array.from(list.querySelectorAll('.pagination__item')).filter(function (item) {
    return /^\d+$/.test(item.textContent.trim());
  });
}

function updateActivePageIndicator() {
  var items = document.querySelectorAll('#product-grid > li[data-page-index]');
  if (items.length === 0) return;

  var currentActivePage = '1';
  var scrollPosition = window.scrollY || window.pageYOffset;
  var windowHeightHalf = window.innerHeight / 2;

  for (var i = 0; i < items.length; i++) {
    var elementTop = items[i].getBoundingClientRect().top + scrollPosition;
    if (scrollPosition + windowHeightHalf >= elementTop) {
      currentActivePage = items[i].getAttribute('data-page-index');
    }
  }

  var pagerItems = getPaginationPageItems();

  pagerItems.forEach(function (item) {
    var linkText = item.textContent.trim();
    var isActive = linkText === String(currentActivePage);

    item.classList.remove('pagination__item--current', 'light');
    item.removeAttribute('aria-current');

    if (isActive) {
      item.classList.add('pagination__item--current', 'light');
      item.setAttribute('aria-current', 'page');
    }
  });
}

function initPaginationIndicator() {
  if (paginationIndicatorInitialized) return;
  paginationIndicatorInitialized = true;

  window.addEventListener('scroll', updateActivePageIndicator);
  setTimeout(updateActivePageIndicator, 500);
}

function initAjaxinate() {
  // Only initialize the pagination indicator. Infinite scroll is enabled by the
  // "Load more" button click.
  initPaginationIndicator();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAjaxinate);
} else {
  initAjaxinate();
}

document.addEventListener('click', function (event) {
  var button = event.target.closest('.ajaxinate-load-more');
  if (!button) return;
  if (button.disabled) return;

  var grid = document.getElementById('product-grid');
  var scope = button.closest('.collection, .template-search__results') || (grid ? grid.closest('.collection, .template-search__results') : null);
  if (!scope) return;

  // Enable infinite scroll mode and hide the button via CSS.
  scope.classList.add('ajaxinate-infinite-active');
  button.disabled = true;
  button.setAttribute('aria-busy', 'true');

  window.runAjaxinateEngine();

  // If Ajaxinate doesn't have a next URL, fall back to showing the button again.
  if (!ajaxinateInstance || !ajaxinateInstance.nextPageUrl || !document.getElementById('AjaxinateTargetLink')) {
    scope.classList.remove('ajaxinate-infinite-active');
    button.disabled = false;
    button.removeAttribute('aria-busy');
    return;
  }

  // Load the next page immediately, then rely on scroll-triggered loads.
  ajaxinateInstance.requestPending = true;
  ajaxinateInstance.loadPage();
});

document.addEventListener('shopify:section:load', function (event) {
  if (event.target.querySelector('#product-grid')) {
    setTimeout(window.onProductGridUpdated, 50);
  }
});
